import { render, staticRenderFns } from "./LearningProblem.vue?vue&type=template&id=49294520&scoped=true&lang=pug&"
import script from "./LearningProblem.vue?vue&type=script&lang=ts&"
export * from "./LearningProblem.vue?vue&type=script&lang=ts&"
import style0 from "./LearningProblem.vue?vue&type=style&index=0&id=49294520&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49294520",
  null
  
)

export default component.exports